import { Api } from '../lib'

const TYPE = {
  receive: 'RECEIVE_PRODUCT'
}

const api = new Api()

const fetchProduct = ({keys}) => (dispatch, getState) => api
  .get('product', {
    keys
  })
  .then( product => dispatch({type: TYPE.receive, payload: product.data}) )

export default {
  TYPE,
  fetchProduct
}
